import React from 'react';
import PageHeader from './PageHeader';
import { Card } from './ui/Card';

export function DashboardModuleStats({ items = [] }) {
  if (!items.length) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <Card
            key={item.label}
            className="p-4 sm:p-6 bg-white border border-[#E5E5E5] rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)]"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="w-10 h-10 rounded-[4px] bg-[#0176D3]/10 border border-[#0176D3]/15 flex items-center justify-center text-[#0176D3]">
                {Icon ? <Icon size={18} /> : null}
              </div>
              {item.meta ? (
                <span className="text-[11px] font-semibold text-[#706E6B]">
                  {item.meta}
                </span>
              ) : null}
            </div>
            <div className="text-[11px] font-semibold text-[#706E6B] mb-1">
              {item.label}
            </div>
            <div className="text-2xl font-bold text-[#2E2E2E]">
              {item.value}
            </div>
          </Card>
        );
      })}
    </div>
  );
}

export default function DashboardModuleShell({ title, subtitle, icon, actions, stats, children }) {
  return (
    <div className="sf-page-wrapper">
      <PageHeader title={title} subtitle={subtitle} icon={icon} actions={actions} />
      <DashboardModuleStats items={stats} />
      {children}
    </div>
  );
}
